import { useState } from "react";

import { Box } from "@mui/material";

const DescriptionCell = ({ description, model }) => {
    const [expanded, setExpanded] = useState(false);
    const maxLength = 100;

    const toggleExpanded = (e) => {
        e.stopPropagation();
        setExpanded(!expanded);
    };

    const combinedText = model ? `${description} - ${model}` : description || "";
    const needsTruncate = combinedText.length > maxLength;
    const displayText = expanded
        ? combinedText
        : combinedText.slice(0, maxLength) + (needsTruncate ? "..." : "");

    return (
        <Box
            sx={{
                minWidth: 0,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "Nunito, sans-serif",
                fontSize: 14,
                lineHeight: 1.45,
                color: "#3a3a3c",
            }}
        >
            <Box component="p" sx={{ m: 0 }}>
                {displayText}
            </Box>
            {needsTruncate ? (
                <Box
                    component="button"
                    type="button"
                    onClick={toggleExpanded}
                    sx={{
                        border: "none",
                        background: "none",
                        color: "#F66700",
                        cursor: "pointer",
                        padding: 0,
                        mt: 0.5,
                        fontFamily: "Nunito, sans-serif",
                        fontSize: 14,
                        fontWeight: 700,
                    }}
                >
                    {expanded ? "Close" : "Read more"}
                </Box>
            ) : null}
        </Box>
    );
};

export default DescriptionCell;
